import dayjs from "../utils/dayjs";
import { useSettingsData } from "../contexts/SettingsDataContext";
import { useFormattedDate } from "./useFormattedDate";

export function useIsTemporarilyClosed() {
  const { settings } = useSettingsData();
  const { timezone } = useFormattedDate();

  if (!settings.tempClosedUntil) return false;

  return dayjs()
    .tz(timezone)
    .isBefore(dayjs(settings.tempClosedUntil).tz(timezone));
}
